import { CommunicationSizeComponent, ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';

export const filterDoorType = (coreApi: CoreApi, selectedProduct: Product) => (
  product: Product
) => {
  const orientation = selectedProduct.coreProductId.includes('left') ? 'left' : 'right';

  return product.coreProductId.includes(orientation);
};

export const filterInteriorColors = (coreApi: CoreApi, selectedProduct: Product) => (
  product: Product
) => {
  if (product.type === ProductType.BILLY_DRAWER || product.type === ProductType.BILLY_DESK) {
    return true;
  }

  const selectedEntity = coreApi.entities.getAll().find(e => e.id === selectedProduct.entityId);

  const parent =
    selectedEntity &&
    HierarchyUtils.findInUpwardsHierarchy(selectedEntity, entity =>
      coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM)
    );

  const frameDesign = parent?.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.design;

  const allowedColors = [selectedProduct.design, 'glass', frameDesign];
  return allowedColors.includes(product.design);
};

export const filterInteriorDimensions = (coreApi: CoreApi, selectedProduct: Product) => (
  product: Product
) => {
  if (
    selectedProduct.type === ProductType.BILLY_FRAME_EXTENSION &&
    (product.type === ProductType.BILLY_DESK || product.type === ProductType.BILLY_DRAWER)
  ) {
    return false;
  }

  const selectedEntity = coreApi.entities.getAll().find(e => e.id === selectedProduct.entityId);

  const parent =
    selectedEntity &&
    HierarchyUtils.findInUpwardsHierarchy(selectedEntity, entity =>
      coreApi.entities.isProductType(entity, ProductType.BILLY_FRAME_WITH_SHELVES_ASM)
    );

  const frameSize = parent?.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size;

  if (!frameSize) return false;

  if (
    frameSize?.height > 400 &&
    (product.type === ProductType.BILLY_DRAWER || product.type === ProductType.BILLY_DESK) &&
    frameSize?.width === product.communicatedDimensions.width
  ) {
    return true;
  }

  return (
    product.communicatedDimensions.width === frameSize?.width &&
    product.communicatedDimensions.depth === frameSize?.depth
  );
};

export const filterDeskType = () => (product: Product) => {
  return product.type !== ProductType.BILLY_DESK || product.coreProductId.includes('extended');
};

export const filterDesk = () => (product: Product) => {
  return product.type !== ProductType.BILLY_DESK;
};

export const filterDoorHeights = (coreApi: CoreApi, selectedProduct: Product) => (
  product: Product
) => {
  const selectedEntity = coreApi.entities.getAll().find(e => e.id === selectedProduct.entityId);
  const frameDimensions = selectedEntity?.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size;

  const allowedHeight = (frameDimensions?.height ?? 0) + 100 || 2020;

  const isExtension =
    selectedEntity &&
    coreApi.entities.isProductType(selectedEntity, ProductType.BILLY_FRAME_EXTENSION);

  const blockExtensionDoor = product.communicatedDimensions.height === 350 && !isExtension;
  return product.communicatedDimensions.height < allowedHeight && !blockExtensionDoor;
};
